import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=ba14e666&scoped=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=ba14e666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba14e666",
  null
  
)

export default component.exports